$(document).ready(function () {
    $.extend($.validator.messages, {
        required: 'This field is required!',
        email: 'Please enter a valid e-mail address',
        maxlength: 'Name too long'
    });

    var customer_form = $("#create_customer"),
        updating = false,
        form_create_user = $("#create_customer"),
        confirm_age_error_box = $('#confirm_age_error_box'),
        accept_privacy_error_box = $('#accept_privacy_error_box'),
        password_input = $('#password'),
        password_img = $('#see_password'),
        loading_anim_img = $('.loading-anim'),
        register_button = $('#loyalty_button'),
        email_field = $('#email');

    var password_min_length_error_message = 'Your password must be at least 8 characters long.';

    email_field.on('change', function () {
            let shop = Shopify.shop;
            let email = encodeURIComponent($(this).val());

            let activation_modal = $(".account-activation");
            let tooltip = $('.tooltips');

            activation_modal.hide();
            tooltip.hide();

            delay(function () {
                if (!biotech_day_is_active) {
                    var url = "https://emarsys.biotechusa.com/userEmailExistValid?email=" + email + "&shop=" + shop;
                    $.getJSON(url).then(function (data) {
                        if (data.found) {
                          register_button.prop('disabled', true);

                          if('disabled' == data.state) {
                            $('.account-activation__submit').attr('data-id', data.id);
                            $('.account-activation__submit').attr('data-email', email);
                            activation_modal.show();
                          }
                          else {
                            tooltip.show();
                          }
                        }else{
                            register_button.prop('disabled', false);
                        }
                    });
                } else {
                    register_button.prop('disabled', false);
                }
            }, 500);
        });

    addValidatorRegexpMethod('password_regexp', 'Your Password must contain uppercase and lowercase characters.');

    if (save_phone) {
        addValidatorRegexpMethod('phone_regexp', phone_validation_error);
    }

    $.validator.addMethod(
        'phone_regexp',
        function(value, element, regexp){
            if (this.optional(element)) {
                return true;
            }
            value = value.replace(/\s/g, '')
            return new RegExp(regexp).test(value);
        },
        phone_validation_error
    )

    disableSpaceButton(email_field);

    form_create_user.submit(function (e) {
        e.preventDefault();
        $(".input_error_cont, errorBox, exclamation").remove();
    }).validate({
        rules: {
            'customer[last_name]': {
                validateSpamReg: true,
                maxlength: 40,
                combinedMaxLength: {
                    maxLength: 60,
                    selector: '#first_name'
                },
                notEqualToField: '#first_name'
            },
            'customer[first_name]': {
                validateSpamReg: true,
                maxlength: 40,
                combinedMaxLength: {
                    maxLength: 60,
                    selector: '#last_name'
                },
                notEqualToField: '#last_name'
            },
            'customer[note][phone]': {
                required: false,
                phone_regexp: phone_regex,
                normalizer: function (value) {
                    return value.replace(/\s/g, '')
                }
            },
            'customer[password]': {
                minlength: 8,
                password_regexp: passwordRegexp,
                normalizer: function(value) {
                    return value.replace(/\s/g, '')
                }
            }
        },
        messages: {
            'customer[password]': {
                minlength: function() {
                    return password_min_length_error_message;
                }
            }
        },
        showErrors: function (errorMap, errorList) {
            $.each(errorMap, function (key, value) {
                var errorElement = $("[name='" + key + "']");

                if (key === "confirm_age" || key === 'accept_privacy_policy') {
                    var error_box_name = '#'+ key + '_error_box';
                    var current_error_box = $(error_box_name);
                    $(current_error_box).show();
                    $(current_error_box).html(value);
                } else {
                    if ("customer[password]" == key) {
                        password_img.addClass('hidden');
                    }
                    if ("customer[note][city]" == key) {
                        $('#city ~ .select2 .select2-selection__rendered').css('background-color', '#FFE9EC');
                    }
                    errorElement.after("<div class='input_error_cont'><div class='errorBox'>" + value + "</div></div>");
                    errorElement.css('background-color', '#FFE9EC');
                }
            });

            $(".input_container").each(function () {
                var $this = $(this);
                if ($this.children('.input_error_cont').length > 1) {
                    $this.children('.input_error_cont').not(':first').remove();
                }
            });
        }, submitHandler: function (form) {
            if(save_phone){
                let phone_number = $('#phone_number').val().replace(/\s/g, "");
                $('#phone_number').val(phone_number);
            }

            let raw_referrer = $('#referrer').val();

            if (raw_referrer) {
                let referrer = raw_referrer.replace(/[^0-9]/g, '');
                let tags = $('#customer-tags');
                let referrer_tag = tags.val() + ', referrer_' + referrer;
                tags.val(referrer_tag);
            }
            var data = $(form).serialize();

            /** Mivel a serialize stringgé, url paraméterré alakítja a propokat,
             *  konkatenálással tudjuk bővíteni a customer datát */
            if ($("#accept_newsletter").prop('checked')) {
                data = data + "&customer[accepts_marketing]=true";
            }

            if (updating) {
                return;
            }

            updating = true;

            Cookies.set('cart_item_property_update', 'true', {expires: 14});

            loading_anim_img.removeClass('hidden');

            fetchVerify('login_form').then(recaptcha_data => {
                if (true == recaptcha_data || recaptcha_data.success) {
                    $.post('/account', data)
                        .done(function (data) {
                            var logErrors = $(data).find('.alert-box').text();

                            if (logErrors !== "" && logErrors !== 'undefined') {
                                $(".tooltips").show();
                                loading_anim_img.addClass('hidden');
                                register_button.attr('value', reg_button_submit).prop('disabled', false);
                            } else {
                                if ($("#accept_newsletter").prop('checked')) {
                                    //TODO: itt is setting legyen
                                    $.post('https://emarsys.biotechusa.com/tools/subscribe', {
                                        email: customer_form.find('#email').val(),
                                        fname: customer_form.find('#first_name').val(),
                                        lname: customer_form.find('#last_name').val(),
                                        trigger: loyalty_reg_emarsys_trigger,
                                        source: "UJ_TV_PROGRAM_FELIRATKOZO",
                                        // permanent domainel egyezik.
                                        shop: window.Shopify.shop
                                    }).success(function (emarsys_data) {
                                        if (!emarsys_data.status === 1) {
                                            console.log('Hiba történt a hirlevélre való feliratkozás közben');
                                        } else {
                                            var reg_event_params = {
                                                'event': 'custom_event_',
                                                'EventCategory': 'registration',
                                                'EventLabel': 'registration-landing',
                                                'EventName': 'Customer Registration From Landing'
                                            };

                                            window.dataLayer.push(reg_event_params);
                                        }
                                    }).fail(function () {
                                        console.log('Sajnálatos hiba történt');
                                    });
                                }

                                $('#form').css('display', 'none');
                                $('#success_form').removeClass('hidden');
                                $('.loyalty_success_button').attr('href', window.location.origin);
                            }

                            setTimeout(function () {
                                updating = false;
                            }, 500);
                        }).fail(function () {
                        console.log('error');
                    });
                }
            }).catch((error) => {
                console.log(error)
            });
            return false;
        }
    });

    $('#referrer').val(getParameterByName('referrer'));

    $(".tooltip-btn-two").click(function (event) {
        $(".tooltips").hide();
    });

    $(".tooltip-btn-one").click(function () {
        $(".tooltips").hide();
        window.location.href = window.location.origin + "/account/login";
    });

    $('body').on('click', function () {
        confirm_age_error_box.hide();
    });

    $('#confirm_age').click(function () {
        if ($(this).prop('checked')) {
            let customer_tags = ['Confirm_age', 'New_loyalty', 'created_at: ' + Date.now()];
            if (point_based_loyalty) {
                customer_tags.push('point_based_loyalty');
                if (antavo_enabled) {
                    customer_tags.push('Antavo_loyalty');
                }
                if (emarsys_loyalty) {
                    customer_tags.push('Emarsys_loyalty');
                }
            }

            $('#customer-tags').val(customer_tags.join(', '));
        }
    });

    $("[data-select]").on('input', function () {
        $(this).next('.input_error_cont').remove();
        $(this).css('background-color', 'white');

        if ($(this).prop('type') === 'email') {
            stripVal($(this));
        } else {
            leftTrimVal($(this));
        }
    });

    password_input.on('input', function () {
        if (password_input.val()) {
            password_img.removeClass('hidden');
        } else {
            password_img.addClass('hidden');
        }
    });

    password_img.on('click', function () {
        if (password_input.attr('type') === 'password') {
            password_input.attr('type', 'text');
        } else {
            password_input.attr('type', 'password');
        }
    })

    $('#city').on('input', function () {
        $('#city ~ .select2 .select2-selection__rendered').css('background-color', 'white');
    });
});

$(document).on('click touch', '.account-activation .account-activation__submit', function () {
  const { shop } = Shopify;
  const id = $(this).data('id');
  const email = $(this).data('email');
  const url = 'https://emarsys.biotechusa.com/userGenerateActivationLink?id=' + id + '&shop=' + shop;
  const loading = $('#register .account-activation .submit__loading');
  const submitText = $('#register .account-activation .submit__text');

  loading.show();
  submitText.hide();

  $.getJSON(url).then(function (response) {
    if (response.success === true) {
      const { account_activation_url: activation_url } = response;
      const url = 'https://emarsys.biotechusa.com/sendactivation?shop=' + shop + '&email=' + email + '&activation_url=' + activation_url;

      $.getJSON(url, function () {
          submitText.show();
          loading.hide();

          $('#register .activationSuccess').show();
          $('#register .account-activation').hide();
      });
    }
  });
});

$(document).on('click touch', '#register .activationSuccess .account-activation__resend', function () {
  $('#register .account-activation').show();
  $('#register .activationSuccess').hide();
});
